import { atom } from 'jotai'

import type { State } from './types'

/** I don't know why we need this to be mutable, this is just a clean refactor of existing logic. */
export function makeMutableState(stateDefault: State): State {
  return Object.assign({}, stateDefault)
}

/** I don't know why we need this to be mutable, this is just a clean refactor of existing logic. */
export function makeStateAtom(stateMutable: State) {
  return atom<State>(stateMutable)
}
